import styled from "styled-components";

export const Total = styled.div`
background-color: #EEEFF1;
padding: 3%;
`

export const Container = styled.div`
display: flex;
gap: 3%;
justify-content: center;
align-content: center;
@media (max-width: 768px) {
  display: block;
}
`

export const H1 = styled.h1`
width: 60%;
text-align: center;
margin: auto;
margin-bottom: 10%;
font-weight: 800;
letter-spacing: 2px;
`
export const DivImage = styled.div`
width: 45vw;
@media (max-width: 768px) {
  width: 90vw;
  margin: auto
}
`
export const Image = styled.img`
border-radius: 10px;
width: 100%;
height: 100%;
`

export const Text = styled.div`
width: 40vw;
text-align: center;
font-size: 2.2vh;
margin-left: 4%;
@media (max-width: 768px) {
  width: 90vw;
  margin: auto
} 
`

export const Button = styled.div`
font-weight: 700;
color: white;
border-radius: 8px;
padding:0.5%;
letter-spacing: 1px;
text-align: center;
box-sizing: border-box;
transition: all 400ms ease;
background-color: #1C1240;
width: 10vw;
margin: auto;
margin-top: 5%;
&:hover
{
  background-color: #3E6AEC;
  cursor: pointer;
}
@media (max-width: 768px) {
  width: 25vw
}
`